import { render, staticRenderFns } from "./docFeedback.vue?vue&type=template&id=6a34074e&scoped=true"
import script from "./docFeedback.vue?vue&type=script&lang=js"
export * from "./docFeedback.vue?vue&type=script&lang=js"
import style0 from "./docFeedback.vue?vue&type=style&index=0&id=6a34074e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a34074e",
  null
  
)

export default component.exports